module.exports = __webpack_public_path__ + "static/img/龙头二波.6d996f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/龙头二波.png
// module id = 1ULh
// module chunks = 1